import { Divider, Box, styled, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';
import { ThemeTypography } from './ThemeTypography';

type InfoItem = {
  label: string;
  value?: string | null | ReactNode;
  valueSx?: SxProps;
};

type InfoBoxSectionProps = {
  title: string;
  items: InfoItem[];
  showDividers?: boolean;
  sx?: SxProps<Theme>;
};

// Label column is as wide as the longest label, so values line up without overlapping.
const InfoBox = styled(Box)(() => ({
  display: 'grid',
  gridTemplateColumns: 'max-content 1fr',
  columnGap: '1rem',
  rowGap: '0.5rem',
  alignContent: 'start',
}));

const InfoRow = ({ label, value, valueSx }: InfoItem) => (
  <>
    <ThemeTypography sx={{ color: 'text.secondary' }}>{label}:</ThemeTypography>
    <ThemeTypography sx={valueSx}>{value || '-'}</ThemeTypography>
  </>
);

export const InfoBoxSection = ({ title, items, showDividers = true, sx }: InfoBoxSectionProps) => {
  return (
    <>
      <InfoBox sx={sx}>
        {title.trim() !== '' && (
          <ThemeTypography
            type="body1"
            sx={{ gridColumn: '1 / -1', marginBottom: '0.5rem', textTransform: 'uppercase' }}
          >
            {title}
          </ThemeTypography>
        )}
        {items.map((item, index) => (
          <InfoRow
            key={`${item.label}-${index}`}
            label={item.label}
            value={item.value}
            valueSx={item.valueSx}
          />
        ))}
      </InfoBox>
      {showDividers && <Divider orientation="vertical" variant="middle" flexItem />}
    </>
  );
};
